/**
 * KA Current — ambient living background. Fixed-position CSS-only layer that
 * sits behind every route. Pointer-events: none, GPU transforms only, pauses
 * for prefers-reduced-motion via the sitewide media query.
 */
export function KaCurrent() {
  return <div className="ka-current" aria-hidden="true" />;
}
